<template>
  <div class="pay-trans-details">
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">
            <div class="filter-item" :class="{'border-red':isShowBorderRed}">
              <div class="filter-item-label">
                {{ $t('merchantAccount.complete_time') }}
              </div>

              <el-date-picker
                v-model="search.return_time"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">
                {{ $t('merchant.merchant_no') + '/' + $t('merchant.merchant_name') }}
              </div>
              <SearchAgentSelect v-model="search.merchant_name_no" style="width: 100%" />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.refund_transaction_status') }}</div>
              <el-select v-model="search.status" filterable class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in refundTypeMap"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="filter-operate">
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>

      </el-collapse-transition>
    </div>
    <div class="total-container">
      <div class="total-item">
        {{ $t('customerService.refund_transactions_number_summary') }}: <span style="color:#3855F1;">{{ total_count }}</span>
      </div>
      <div class="total-item">
        {{ $t('customerService.full_refund_summary') }}: <span style="color:#3855F1;">{{ $store.getters.currency }} {{ total_amount | toDivideWithDot }}</span>
      </div>
      <div class="total-item">
        {{ $t('customerService.refund_commission_amount_summary') }}: <span style="color:#3855F1;">{{ $store.getters.currency }} {{ total_fee | toDivideWithDot }}</span>
      </div>
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column min-width="110" :label="$t('merchant.merchant_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_name }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('customerService.refund_transaction_status')" align="center">
          <template slot-scope="scope">
            <el-tag :type="getRefundTypeMapType(scope.row.status)" class="payin-status tag-custom"> {{ getRefundTypeMap(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('data.refund_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ Math.abs(scope.row.this_time_refund_amount) | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('customerService.refund_commission_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ Math.abs(scope.row.agent_commission) | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('merchantAccount.complete_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time }}</span>
          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>

  </div>
</template>

<script>

import { paymentRefundList } from '@/api/settlement/settlement'
import { fetchPageMethodChannelList } from '@/api/components/components'
import { payTransactionStatusMap, refundStatusMap, refundAgentTypeMap } from '@/utils/maps'
import { payinPaymentMethodMap } from '@/maps/transaction'
import { filterEmptyAttr } from '@/utils/common'
import SearchAgentSelect from '@/components/SearchAgentSelect'
import { appointDate } from '@/utils'

export default {
  name: 'Pay_Trans_Details',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    SearchAgentSelect
  },
  data() {
    return {
      showFilterContent: true,
      search: {
        return_time: [appointDate(-3), appointDate()],
      },
      paymentMethodArr: [
        { label: 'Bill Payment', value: 2 },
        { label: 'QR Code', value: 1 },
        { label: 'Bank Transfer', value: 3 }
      ],
      payinChannelList: [],
      tableData: [],
      total_amount: 0,
      total_fee: 0,
      total_count: 0,
      full_refund_summary: 0,
      return_fee_summary: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0,
        cur_page: 1,
        next_page_url: false
      },
      detailId: '',
      downloading: false,
      isShowBorderRed: false
    }
  },
  computed: {
    getRefundTypeMapType() {
      return function(value) {
        return refundAgentTypeMap(value).type
      }
    },
    getRefundTypeMap() {
      return function(value) {
        return refundAgentTypeMap(value).label
      }
    },
    getRefundStatusMapType() {
      return function(value) {
        return refundStatusMap(value).type
      }
    },
    getRefundStatusMap() {
      return function(value) {
        return refundStatusMap(value).label
      }
    },
    payTransactionStatusArr() {
      return payTransactionStatusMap()
    },
    compFilterPaymentChannel() {
      if (!this.search.pay_product_type) {
        return this.payinChannelList
      }
      const arr = this.payinChannelList.filter(item => {
        if (this.search.pay_product_type === '4,5') {
          return [4, 5].includes(item.payment_method)
        }
        return item.payment_method === this.search.pay_product_type
      })
      return arr
    },
    getPayinPaymentMethodMap() {
      return function(value) {
        if ([4, 5].includes(value)) {
          return payinPaymentMethodMap('4,5').label
        }
        return payinPaymentMethodMap(value).label
      }
    },
    payinPaymentMethodMap() {
      let list = payinPaymentMethodMap()
      list = list.filter(item => {
        if (item.type === 'hide') {
          return false
        }
        return true
      })
      return list
    },
    refundTypeMap() {
      return refundAgentTypeMap()
    },
    refundStatusMap() {
      return refundStatusMap()
    },
    refundStatusLabelMap() {
      return function(value) {
        return refundStatusMap(value).label
      }
    }
  },
  created() {
    this.getAllChannelList()
    this.handleFilter()
  },
  methods: {
    getAllChannelList() {
      fetchPageMethodChannelList().then(res => {
        if (res.code === 10000) {
          this.payinChannelList = res.data || []
        }
      })
    },
    getPaymentDetailInfo(params) {
      this.listLoading = true
      paymentRefundList(params).then(res => {
        if (res.code === 10000) {
          const { total = 15, list = [], current = 1, hasNext = false, total_refund_amount, total_commission, total_refund_count, full_refund_summary, return_fee_summary } = res.data
          this.listQuery.total = total
          this.listQuery.page = params.page ? params.page : 1
          this.listQuery.cur_page = current
          this.listQuery.next_page_url = hasNext
          this.tableData = list
          this.total_amount = total_refund_amount
          this.total_fee = total_commission
          this.total_count = total_refund_count
          this.full_refund_summary = full_refund_summary
          this.return_fee_summary = return_fee_summary
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    getParams(otherParams = {}) {
      const { return_time = [], status, ...otherSearch } = this.search
      let params = {
        transaction_return_time_start: return_time && return_time[0] + ' 00:00:00',
        transaction_return_time_end: return_time && return_time[1] + ' 23:59:59',
        status: 2,
        ...otherSearch,
        ...otherParams
      }
      if ((!return_time || return_time.length === 0)) {
        this.$message.warning('pls enter at least one query date!')
        return null
      }
      params = filterEmptyAttr(params)
      return params
    },

    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      this.getPaymentDetailInfo(params)
    },

    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    },

    onClickPaginator() {
      const { page, limit } = this.listQuery
      const params = {
        page,
        limit
      }
      this.handleFilter(params)
    },
    confirmPaginator(page) {
      const params = {
        page
      }
      this.handleFilter(params)
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-warning-outline{
  position: relative;
  top: 2px;
  color:  #4B5567;
  font-size: 16px;
}
.pay-trans-details{
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 230px;
    margin-right: 5px;
  }
  .search-frame-order{
    width:200px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .picker{
    width: 230px
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .detailTxt{
    font-size: 12px;
    color: #3579FF;
    text-decoration: underline;
     cursor: pointer;
  }
  .total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
    .total-item:not(:last-child){
      border-right: 1px solid #D3D7DF;
    }
  }
  .total{
    border-top: 1px solid #D5D8DE;
    padding: 24px 24px 0 24px;
    &-title{
      font-size: 12px;
      line-height: 17px;
      color: #606266;
    }
    &-num{
      margin-top: 10px;
      padding-bottom: 20px;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: #303133;
    }
  }
}
.status-wrap {
  display: inline-block;
  position:relative;
  .status-tip-wrap {
    position:absolute;
    top:40%;
    transform:translateY(-50%);
    right:-20px;
  }
}

.wayBill_item {
  padding: 10px 20px !important;
}
</style>
